import _taggedTemplateLiteral from "/home/runner/work/is-eth-congested-website/is-eth-congested-website/node_modules/@babel/runtime/helpers/esm/taggedTemplateLiteral";

var _templateObject, _templateObject2;

import React from 'react';
import styled from 'styled-components';
import { Button as MuiButton } from '@material-ui/core';
var StyledButton = styled(MuiButton)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  margin-left: 12px;\n"])));

var Button = function Button(props) {
  return React.createElement(StyledButton, Object.assign({
    color: "primary",
    variant: "contained"
  }, props));
};

Button.displayName = 'Newsletter.Button';
var ButtonExtra = styled(Button)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral([""])));
export default ButtonExtra;